import { AnimatePresence } from 'motion/react';

import { PatternBanner } from '@components/patterns';

import { ENV } from '@utils/env';

import css from './styles.module.css';

export function EnvironmentBanner() {
  return (
    <AnimatePresence initial={false}>
      {ENV.environment === 'staging' && (
        <PatternBanner
          className={css.root}
          trackHeightWith="--environment-height"
        >
          Staging
        </PatternBanner>
      )}
    </AnimatePresence>
  );
}
